module.exports = __webpack_public_path__ + "static/media/wisedb1.7525df81.png";